import { GET_SPECIALTIES_ACTION } from '@/store';

export default {
  created: function () {
    if (!(this.$store.state.specialtyOptions || []).length) {
      this.$store.dispatch(GET_SPECIALTIES_ACTION);
    }
  },
};
